import React from 'react';
import {connectWithCore} from 'framework/hocs';
import {ConfigRow as _ConfigRow} from 'app-ui-componentlibrary/dist/componentLibrary/layout/ConfigRow';
import contentMap from 'componentLibrary';

export const ConfigRow = (props) => <_ConfigRow {...props} {...{contentMap}} />;
export const DynamicRow = connectWithCore(ConfigRow);
export default DynamicRow;
